import WidgetsService from '@/services/WidgetsService'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {
        Loading
    },
    created: function () {
        this.getWidget();
    },
    methods: {
        btnConnectText: function () {
            return (!this.widget.isActive) ? 'Подключить' : 'Отключить';
        },
        btnConnectClass: function () {
            return (!this.widget.isActive) ? 'danger' : 'success';
        },
        btnChangeDisabled (){
            return this.onLoad;
        },
        // Получаем виджет
        async getWidget (callback) {
            this.disabledField = true;
            await WidgetsService.getWidget(this.widgetId).then(response => {
                if(!response.data.result ) {
                    this.disabledField = false;   
                    if(callback) return callback();
                    return;
                }
                this.widget = response.data.result;

                if(!response.data.result.settings) {
                    this.disabledField = false;   
                    if(callback) return callback();
                    return;
                }
                this.settings = response.data.result.settings;   

                if(callback) return callback(); // обязательно в колбеке какрывать загрузку
                else this.disabledField = false;  

            }).catch(err => {
                return console.log(err);
            });
        },
        async changeWidgetStatus () {
            this.onLoad = true;
            await WidgetsService.updateWidgetStatus(!this.widget.isActive, this.widgetId);
            this.getWidget();
            this.onLoad = false;
        },
        showAlert(type, title, text) {
            console.log(text);
            this.$notify({
                group: 'foo',
                type: type,
                title: title,
                text: text
            });
        },
        // Сохраняем настройки
        async saveSettings () {
            this.disabledField = true;
            await WidgetsService.updateWidgetSettings(this.widgetId, this.settings).catch(err => {  return console.log(err); });
            console.log(this.widgetId, this.settings);
            this.showAlert('success', 'Успех!', 'Настройки успешно сохранены!');
            this.disabledField = false;
        },
    }
}
